import { Pipe, PipeTransform } from '@angular/core';
import { DocumentService } from '../../client-core/services';
import { AuthService } from 'app/+auth/auth.service';

@Pipe({ name: 'documentUrl' })
export class DocumentUrlPipe implements PipeTransform {

    constructor (private documentService: DocumentService, private authService: AuthService) {

    }

    /**
     * transforms a document id into a url
     * @param documentId Id of the document
     * @param args args[0] optional default url if document id is null
     */
    transform(documentId: number, ...args: any[]) {
        console.log(">>DocumentUrlPipe", documentId)
        if (documentId) {
            return this.documentService.getDownloadUrlFor(documentId) + `?sitename=${this.authService.getSiteName()}`;
        }
        if(args[0])
            return args[0];

        return null;
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/pipes/document.url.pipe.ts